import Container from "Components/Container/Container";
import React from "react";
import { useTranslation } from "react-i18next";

const Hero = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-black pt-[10vh] ">
      <Container>
        <div className="flex  items-center py-14">
          <h1 className="text-secondary text-4xl font-semibold">
            {t("our_Certificates")}
          </h1>
        </div>
      </Container>
    </div>
  );
};

export default Hero;
